import { Button, Typography } from "@material-ui/core"
import { postEcommOrdersShareConfigurator } from "api"
import { trackPopUpOpen } from "common/analytics"
import FormikForm from "common/bit/form/FormikForm"
import { useEffect, useState } from "react"
import FormErrorState from "reusable/formsComp/FormErrorState"
import FormInput from "reusable/formsComp/FormInput"
import FormSuccessState from "reusable/formsComp/FormSuccessState"
import ClassicPopUp from "reusable/popups/ClassicPopUp"
import { useTypedSelector } from "store"
import styled from "styled-components"
import { FormStatus } from "../testDrive/TestDrivePopup"
import schemaSendEmail from "./SchemaSendEmail"

const StyledClassicPopup = styled(ClassicPopUp)`
  h2 {
    font-size: 24px;
  }
`

const StyledWrapper = styled.div`
  padding: 20px;
`

const StyledFormDiv = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 2px;
  width: 100%;
`

const StyledRequiredFields = styled(Typography).attrs({ variant: "caption" })`
  color: ${(p) => p.theme.colors.mazdaRed};
  margin-left: auto;
`

const StyledRowCol = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  margin-top: auto;
  gap: 2px;
  ${(p) => p.theme.breakpoints.up("md")} {
    flex-direction: row;
    column-gap: 16px;
  }
`
const StyledFormInput = styled(FormInput)`
  margin: 0;
  label[data-shrink="true"] {
    transform: translate(-4px, 4px) scale(0.75);
  }
  legend {
    width: 0;
  }
`

const StyledWrap = styled.div`
  width: 100%;
  max-width: 320px;
`

const StyledButton = styled(Button)`
  margin: 20px 0px;
  height: 45px;
  background: ${(p) => p?.theme?.colors?.black};
  color: white;
  :hover {
    background: ${(p) => p?.theme?.colors?.steel};
    outline: none;
  }
`

// const StyledFormikCheckboxField = styled(FormikCheckboxField)`
//   /* margin-top: 30px; */
//   width: 100%;
//   padding-bottom: 10px;
//   span {
//     user-select: none;
//     font-size: 16px;
//     white-space: pre-line !important;
//   }

//   span[class*="PrivateSwitchBase-root"] {
//     padding: 9px;
//     &:focus {
//       border: 2px dashed white;
//       outline: 3px dashed #0e3487;
//       outline-offset: 2px;
//     }
//   }
// `

type SendMailPopupProps = {
  open: boolean
  onClose: () => void
}

const initialValues = {
  fullName: "",
  email: "",
}

const SendMailPopup = ({ open, onClose }: SendMailPopupProps) => {
  const [formStatus, setFormStatus] = useState<FormStatus>(FormStatus.Normal)
  const { selectedDetailingCode } = useTypedSelector((state) => state.detailing)
  const { selectedColorCode } = useTypedSelector((state) => state.color)
  const { selectedUpholsteryCode } = useTypedSelector(
    (state) => state.upholstery
  )
  const { selectedAccessoriesCodes } = useTypedSelector(
    (state) => state.accessories
  )
  useEffect(() => {
    if (open) {
      trackPopUpOpen("showrooms_send_summery_email")
    }
    if (!open) {
      setFormStatus(FormStatus.Normal)
    }
  }, [open])
  return (
    <StyledClassicPopup
      open={open}
      onClose={onClose}
      title={
        formStatus === FormStatus.Success
          ? "שלחנו לך למייל את הקטלוג הדיגיטלי"
          : "שליחת הסיכום למייל שלך"
      }
    >
      <StyledWrapper>
        {formStatus === FormStatus.Normal && (
          <FormikForm
            validationSchema={schemaSendEmail}
            initialValues={initialValues}
            onSubmit={async (values) => {
              try {
                const { data } = await postEcommOrdersShareConfigurator({
                  isMailing: false,
                  firstName: values.fullName.split(" ")[0],
                  lastName: values.fullName.split(" ")[1],
                  email: values.email,
                  shopLink: location.href.replace("showroomsscreens/", "shop/"),
                  finishingLevelCode: selectedDetailingCode,
                  colorCode: selectedColorCode,
                  upholsteryCode: selectedUpholsteryCode,
                  carExtraCodes: selectedAccessoriesCodes,
                })
                if (data.body) {
                  setFormStatus(FormStatus.Success)
                } else {
                  setFormStatus(FormStatus.Error)
                }
              } catch (e) {
                setFormStatus(FormStatus.Error)
              }
            }}
            render={(formik) => (
              <StyledFormDiv>
                <StyledRequiredFields>* שדות חובה</StyledRequiredFields>
                <StyledRowCol>
                  <StyledFormInput
                    name="fullName"
                    label="שם מלא"
                    required
                    autoComplete="name"
                    marginTop={0}
                  />
                </StyledRowCol>
                <StyledRowCol>
                  <StyledFormInput
                    name="email"
                    label="אימייל"
                    required
                    autoComplete="email"
                    type="email"
                    marginTop={0}
                  />
                </StyledRowCol>

                {/* <StyledFormikCheckboxField
                  name="acceptTerms"
                  label={` הסיכום ישלח לכתובת המייל.
                   הפרטים האישיים לא ישמרו, לא יעשה בהם כל שימוש נוסף`}
                  required
                  classes={{ root: "orderCheckbox" }}
                /> */}
                <Typography>
                  הסיכום ישלח לכתובת המייל. הפרטים האישיים לא ישמרו, לא יעשה בהם
                  כל שימוש נוסף
                </Typography>
                <StyledWrap>
                  <StyledButton
                    disabled={formik.isSubmitting}
                    fullWidth
                    variant="text"
                    type={"submit"}
                  >
                    {"שליחה"}
                  </StyledButton>
                </StyledWrap>
              </StyledFormDiv>
            )}
          />
        )}

        {formStatus === FormStatus.Error && <FormErrorState />}
        {formStatus === FormStatus.Success && (
          <FormSuccessState
            title={"\u00A0"}
            subtitle="נציגנו ישמחו לעמוד לרשותך בכל שאלה בדרך למאזדה החדשה והמרגשת שלך"
          />
        )}
      </StyledWrapper>
    </StyledClassicPopup>
  )
}

export default SendMailPopup
